import { useEffect, useState } from 'react';
import { Spinner } from "components/ui";
import useLoader from 'hooks/useLoader';

export default function GlobalLoader() {
  const { isLoading } = useLoader();
  const [show, setShow] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let timeout;

    if (isLoading) {
      // Show loader immediately when requests start
      setFadeOut(false);
      setShow(true);
    } else {
      // Start fade out animation
      setFadeOut(true);
      // Remove from DOM after animation completes
      timeout = setTimeout(() => {
        setShow(false);
      }, 300);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isLoading]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${fadeOut ? 'opacity-0' : 'opacity-80'
        }`}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md" />

      {/* Loader Container */}
      <div className="relative z-10 flex flex-col items-center gap-4 animate-in fade-in zoom-in duration-200">
        {/* Modern Spinner */}
        <Spinner color="primary" className="size-10" />

        {/* Loading text with dots animation */}
        {/* <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Loading
          </span>
          <div className="flex gap-1">
            <span className="w-1.5 h-1.5 bg-gray-700 dark:bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <span className="w-1.5 h-1.5 bg-gray-700 dark:bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <span className="w-1.5 h-1.5 bg-gray-700 dark:bg-gray-300 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        </div> */}
      </div>
    </div>
  );
}
